import apiClient from '../axios.js'

/**
 * 客戶訂閱管理 API（客戶端）
 */
export const subscriptionService = {
    /**
     * 獲取當前登入客戶的訂閱資訊
     * @returns {Promise<Object>} 訂閱資訊（包含訂閱狀態、交易記錄、訂閱歷史等）
     */
    getMySubscription: async () => {
        const response = await apiClient.get('/client-subscriptions/me')
        return response
    },

    /**
     * 取消訂閱自動續約（目前週期仍可使用至到期日）
     */
    cancelMySubscription: async () => {
        const response = await apiClient.post('/client-subscriptions/me/cancel', {})
        return response
    },
}
